import { useEffect } from 'react';
import styles from './BootstrapVideoOverlay.module.scss';
import logoWhite from '@/shared/img/logo_white.svg';

type BootstrapVideoOverlay = {
  onVideoCompleted: () => void;
};

const FALLBACK_TIMEOUT_MS = 2500;

export const BootstrapVideoOverlay: React.FC<BootstrapVideoOverlay> = ({
  onVideoCompleted,
}) => {
  useEffect(() => {
    const timer = setTimeout(onVideoCompleted, FALLBACK_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [onVideoCompleted]);

  return (
    <div className={styles.fullScreenVideoLoader}>
      <video autoPlay muted playsInline className={styles.blurredVideo}>
        <source src="/video/first.mp4" type="video/mp4" />
      </video>
      <div className={styles.videoOverlay}>
        <img src={logoWhite} alt="Obraz Logo" className={styles.logoOnVideo} />
      </div>
    </div>
  );
};
